<template>
  <div class="stars">
    <div
      class="ratting_star"
      v-for="n in 5"
      :key="n"
      @click="rate(n)"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 55.97 53.95"
      >
        <path
          :fill="n <= current ? activeColor : inactiveColor"
          d="M55.97,21.08c0-1.92-1.44-3.51-3.35-3.71l-14.67-1.54-6.41-13.59c-.65-1.37-2.04-2.25-3.56-2.25s-2.91.88-3.56,2.25l-6.41,13.59-14.67,1.54c-1.91.2-3.35,1.79-3.35,3.71,0,1.09.48,2.12,1.31,2.83l11.6,9.92-3.64,15.25c-.28,1.18,0,2.41.74,3.37.76.96,1.89,1.51,3.12,1.51.79,0,1.55-.23,2.2-.66l12.65-8.41,12.65,8.41c.65.43,1.41.66,2.2.66,1.22,0,2.36-.55,3.12-1.51.76-.96,1.03-2.18.74-3.37l-3.64-15.25,11.6-9.92c.83-.71,1.31-1.74,1.31-2.83h.02Z"
        />
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StarsComp_',
  props: {
    modelValue: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      current: this.modelValue,
      activeColor: '#fadb20',
      inactiveColor: '#ccc'
    }
  },
  methods: {
    rate(value) {
      this.current = value
      this.$emit('update:modelValue', value)
      this.$emit('rated', value)
    }
  }
}
</script>

<style scoped>
.stars {
  display: flex;
  gap: 6px;
  cursor: pointer;
}
.ratting_star svg {
  width: 30px;
  height: 30px;
}
</style>
